import { Heading, Spacer } from '@zillow/constellation';

import { PartialMessage } from '@zg-rentals/backend-styled-components';

import type { GetHelpArticle, GetHelpArticlesResponse } from './actions';
import { StyledAnchor } from './StyledComponents';
interface HelpArticlesContentProps {
  data: GetHelpArticlesResponse;
  error: boolean;
}

export const HelpArticlesContent = ({ data, error }: HelpArticlesContentProps) => {
  //  if there is an error just don't show the articles section
  if (error || !data) return null;

  const renderHelpArticle = (helpArticle: GetHelpArticle) => {
    const { title, contents } = helpArticle;

    return (
      <>
        <Spacer marginBottom="xs">
          <PartialMessage partialMessages={title} linkComponent={StyledAnchor} fontType="bodySmall" />
        </Spacer>
        {contents?.length > 0 && (
          <Spacer marginBottom="md">
            {contents?.map((content) => {
              const key = content.reduce((prevText, textDto) => textDto.text + prevText, '');
              return (
                <PartialMessage
                  key={`help-article-contents-${key}`}
                  partialMessages={content}
                  linkComponent={StyledAnchor}
                  fontType="bodySmall"
                />
              );
            })}
          </Spacer>
        )}
      </>
    );
  };

  return (
    <Spacer data-testid="HelpArticles" marginLeft={{ default: 0, xl: 'xl' }} marginTop={{ default: 'lg', xl: 0 }}>
      {data?.heading && (
        <Heading marginBottom="md" level="6">
          {data?.heading}
        </Heading>
      )}
      {data?.helpArticles?.map((helpArticle: GetHelpArticle) => {
        return (
          <div key={`help-article-${helpArticle.title[0].url || helpArticle.title[0].text}`}>
            {renderHelpArticle(helpArticle)}
          </div>
        );
      })}
    </Spacer>
  );
};
